import { MOCK_CUSTOMER_DETAILS } from "../data/mockCustomerDetails";
import { MOCK_CUSTOMERS } from "../data/mockCustomers";
import type { CustomerDetail, CustomerDetailFields, CustomerRow } from "../types";

function defaultDetailFields(row: CustomerRow): CustomerDetailFields {
  const [industry = "—", region = "—"] = row.industryLine
    .split("·")
    .map((s) => s.trim());
  const monitored =
    row.lifecycleStatus === "ACTIVE"
      ? Math.round(row.endpoints * 0.95)
      : 0;

  return {
    breadcrumbLabel: row.name.split(" ")[0] ?? row.name,
    orgLogo: null,
    industry,
    hq: `${region} · local time`,
    createdLabel: `${row.lastActivityLabel} by R Sreenivas`,
    accountManager: "R Sreenivas",
    endpointsMonitored: monitored,
    compliancePosturePercent: row.lifecycleStatus === "ACTIVE" ? 58 : null,
    complianceFrameworksLabel: "ISO 27001, PCI DSS, GDPR, DPDP, CCPA",
    monitoringCadence: "On demand",
    nextScanLabel: "No scheduled scan",
    organisation: {
      legalEntity: row.name,
      tradeName: row.name,
      primaryWebsite: "—",
      companySize: "—",
      planAndSeats: `${row.plan} · ${row.endpoints.toLocaleString("en-US")} endpoint seats`,
      contract: "—",
    },
    primaryUser: {
      name: "—",
      email: "—",
      role: "—",
      roleTitle: "—",
      phone: "—",
      firstLogin: "—",
    },
    welcomeLink: {
      status:
        row.lifecycleStatus === "WELCOME_LINK_EXPIRED"
          ? "Expired"
          : row.lifecycleStatus === "AWAITING_FORWARD_TO_CLIENT"
            ? "Awaiting forward"
            : row.lifecycleStatus === "AWAITING_FIRST_LOGIN"
              ? "Issued"
              : "Consumed",
      statusTone:
        row.lifecycleStatus === "WELCOME_LINK_EXPIRED"
          ? "crit"
          : row.lifecycleStatus === "AWAITING_FORWARD_TO_CLIENT"
            ? "warn"
            : row.lifecycleStatus === "AWAITING_FIRST_LOGIN"
              ? "med"
              : "ok",
      issued: `${row.lastActivityLabel} · by R Sreenivas`,
      boundTo: "—",
      validitySelected: "30 days",
      emailSent: row.lifecycleStatus === "ACTIVE",
    },
    recentActivity: [
      {
        when: row.lastActivityLabel,
        actor: "R Sreenivas",
        event: "customer.viewed",
        detail: `Opened customer dossier ${row.customerId}`,
      },
    ],
  };
}

export function getCustomerRowByCustomerId(
  customerId: string,
): CustomerRow | undefined {
  return MOCK_CUSTOMERS.find((row) => row.customerId === customerId);
}

export function getCustomerDetail(
  customerId: string,
): CustomerDetail | undefined {
  const row = getCustomerRowByCustomerId(customerId);
  if (!row) {
    return undefined;
  }
  const extra =
    MOCK_CUSTOMER_DETAILS[customerId] ?? defaultDetailFields(row);
  return { ...row, ...extra };
}
